import { Asset } from 'expo-asset';

import { useSoundPreferences } from './lesson-player.context';
import { useSimpleSound } from './use-simple-sound';

export function useSuccessSound() {
  const { areSoundEffectsEnabled } = useSoundPreferences();
  return useSimpleSound(
    Asset.fromModule(require('../assets/sounds/success.mp3')),
    areSoundEffectsEnabled
  );
}
